import { IModel } from '../interfaces/model';

export class Model implements IModel {
  static strings = {};
  static fields = [];
  static nested = {};
}
